import { render, staticRenderFns } from "./PDF-viewer.vue?vue&type=template&id=66fb4dbe&scoped=true&"
import script from "./PDF-viewer.vue?vue&type=script&lang=js&"
export * from "./PDF-viewer.vue?vue&type=script&lang=js&"
import style0 from "./PDF-viewer.vue?vue&type=style&index=0&id=66fb4dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb4dbe",
  null
  
)

export default component.exports